
import { computed, defineComponent } from 'vue'

import TableSimple from '@/components/elements/TableSimple.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import { numberFormatAddComma } from '@/utils/commonMethods'
import HospitalContactBtn from '@/components/block/HospitalContactBtn.vue'
export default defineComponent({
  components: {
    TableSimple,
    HeadingLv2,
    HospitalContactBtn
  },

  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },

  setup(props: any) {
    const recruitData = computed(() => {
      return [
        { th: '応募方法', td: props.detail.qualification || '' },
        { th: '試験日', td: props.detail.test_day || '' },
        { th: '選考方法', td: props.detail.selection_process || '' },
        {
          th: '前年度採用者数',
          td: props.detail.employees_num
            ? numberFormatAddComma(props.detail.employees_num) + '人'
            : ''
        },
        {
          th: '研修医の主な出身大学',
          td: props.detail.j_graduating_school
            ? props.detail.j_graduating_school.join('、')
            : ''
        }
      ]
    })
    const salaryData = computed(() => {
      return [
        { th: '給与', td: props.detail.hospital_junior_recruits_salary || '' },
        { th: '賞与', td: props.detail.bonus || '' },
        { th: '勤務時間', td: props.detail.working_hours || '' },
        {
          th: '時間外勤務',
          td: props.detail.overtime_hours_mavg || ''
        },
        {
          th: '当直回数',
          td: props.detail.shifts_num ? String(props.detail.shifts_num) : ''
        },
        { th: '当直時の<br>勤務体制', td: props.detail.shifts_system || '' },
        { th: '休暇・休日', td: props.detail.holiday_note || '' }
      ]
    })
    const trainingData = computed(() => {
      return [
        { th: '研修制度', td: props.detail.rehiring || '' },
        { th: '研修医のための宿舎', td: props.detail.house || '' },
        { th: '福利厚生', td: props.detail.welfare || '' }
      ]
    })
    const contactData = computed(() => {
      return [
        { th: '問い合わせ担当者', td: props.detail.recruiter },
        { th: 'TEL', td: props.detail.tel },
        { th: 'FAX', td: props.detail.fax },
        { th: 'メール', td: props.detail.email, mail: true }
      ]
    })
    const isNotEmptyData = (data: any) => {
      let res = false
      data.forEach((el: any) => {
        if (el.td) res = true
      })
      return res
    }

    return {
      recruitData,
      salaryData,
      trainingData,
      contactData,
      isNotEmptyData
    }
  }
})
